export default "__VITE_ASSET__BHS3b8XB__"